import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const TestApp = () => {
  const [groupName, setGroupName] = useState("");
  const [token, setToken] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);

  // Fetch Group Messages
  const fetchMessages = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/get-message",
        {
          groupName,
          token,
        }
      );
      setMessages(response.data.groupMessages);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setLoading(false);
    }
  }, [groupName, token]);

  // Send a New Message
  const sendMessage = async () => {
    if (!message) return;
    try {
      await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/sendmessage",
        {
          token,
          groupName,
          messageData: {
            isImage: false,
            message,
          },
        }
      );
      setMessage("");
      fetchMessages(); // Refresh message list
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  // Handle Component Mount (Only fetch messages if initialized)
  useEffect(() => {
    if (initialized) {
      fetchMessages();
    }
  }, [initialized, fetchMessages]);

  const handleInitialization = () => {
    if (!token || !groupName) {
      alert("Please provide both token and group name");
      return;
    }
    setInitialized(true); // Mark as initialized once the token and group name are set
  };

  return (
    <div style={{ padding: "20px" }}>
      {!initialized ? (
        <div>
          <h2>Initialize Chat Room</h2>
          <div>
            <input
              type="text"
              placeholder="Enter Group Name"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              style={{ padding: "10px", width: "300px", marginBottom: "10px" }}
            />
          </div>
          <div>
            <input
              type="text"
              placeholder="Enter Token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              style={{ padding: "10px", width: "300px", marginBottom: "10px" }}
            />
          </div>
          <button
            onClick={handleInitialization}
            style={{ padding: "10px", marginTop: "10px" }}
          >
            Initialize Chat
          </button>
        </div>
      ) : (
        <div>
          <h1>Chat Room: {groupName}</h1>

          <div>
            <h3>Messages:</h3>
            {loading ? (
              <p>Loading messages...</p>
            ) : (
              <ul>
                {messages.map((msg) => (
                  <li key={msg._id}>
                    <strong>{msg.sender}</strong>: {msg.message}{" "}
                    <span style={{ color: "gray", fontSize: "0.8em" }}>
                      ({new Date(msg.date).toLocaleString()})
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div style={{ marginTop: "20px" }}>
            <input
              type="text"
              placeholder="Type your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              style={{ padding: "10px", width: "300px" }}
            />
            <button
              onClick={sendMessage}
              style={{ padding: "10px", marginLeft: "10px" }}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestApp;
